import React, { Component } from 'react'

import {connect} from "react-redux";
import {getFotografiaPlanta} from "../../../actions/orderActions";
import EtapaCardList from "./EtapaCardList";
import Typography from "@material-ui/core/Typography";
import InfoIcon from "@material-ui/icons/Info";
import Button from "@material-ui/core/Button";
import SearchIcon from "@material-ui/icons/Search";
import {withStyles} from "@material-ui/core/styles";

const NA = 'N/A'


const styles = theme => ({
    button: {
        margin: theme.spacing(1)
    },
    infoIcon: {
        verticalAlign: "middle"
    },
    textCenter: {
        textAlign: 'center'
    }
});



class FotografiaPlanta extends Component {
    constructor(props) {
        super(props)
        this.onClickUpdate = this.onClickUpdate.bind(this);
        this.renderUpdateComponent = this.renderUpdateComponent.bind(this);
    }

    componentDidMount() {
        this.onClickUpdate();
    }

    onClickUpdate(){
        this.props.getFotografiaPlanta();
    }

    renderUpdateComponent() {
        const { classes } = this.props;


        return (
            <div className={classes.textCenter}>
                <Typography variant="subtitle1" align="center">

                    <Button
                        variant="contained"
                        color="secondary"
                        className={classes.button}
                        onClick={this.onClickUpdate}
                    >
                        Atualizar
                        <SearchIcon className={classes.leftMargin}  />
                    </Button>
                </Typography>
            </div>
        )
    }


    renderNoDataScreen() {
        const { classes } = this.props;
        return (
            <React.Fragment>
                {this.renderUpdateComponent()}
                {/*<Typography align="center">*/}
                {/*    <InfoIcon className={classes.infoIcon} /> Por favor informe a Autoclave e Ciclo visualizar detalhes.*/}
                {/*</Typography>*/}
            </React.Fragment>
        )
    }




    render() {
      //  const { match: { params } } = this.props;

        // console.log(this.props.ordemServico.fotografiaPlanta);

        return (
            <React.Fragment>
                {this.renderUpdateComponent()}
                <EtapaCardList/>
            </React.Fragment>
        );
    }
}

const mapStateToProps = (state) => {
    return {

        ordemServico: state.ordemServicoReducer

    }
}

export default connect(mapStateToProps, {getFotografiaPlanta  }) ((withStyles(styles, {withTheme: true})) (FotografiaPlanta));
